// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress {
  width: 100%;
  padding: 15px;
  display: flex;
}
.progress .step {
  width: 33.33%;
  text-align: center;
}
.progress .step div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.progress .step div ion-checkbox {
  margin: 0 10px;
  --checkbox-background-checked: #C1C1C1;
  --border-color-checked: #C1C1C1;
  --checkmark-color: #C1C1C1;
  --border-radius: 50%;
  pointer-events: none;
}
.progress .step div div {
  width: 50%;
  height: 2px;
  background: #C1C1C1;
}
.progress .step div .active {
  background: var(--accent-color);
}
.progress .step div ion-checkbox.active {
  background: transparent;
  --checkbox-background-checked: var(--accent-color);
  --border-color-checked: var(--accent-color);
}

.bubble {
  position: relative;
  width: 85px;
  margin: 0 auto 20px;
  aspect-ratio: 1;
  background: white;
  display: flex;
  border-radius: 50%;
}
.bubble img {
  width: 75%;
  margin: auto;
}

.bubble::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -6px;
  z-index: -1;
  width: 18px;
  height: 18px;
  background: inherit;
  transform: translateX(-50%) rotate(45deg);
}

.overview-card {
  --background: #070707;
  background: #070707;
  border: 1px solid #8A5B4A;
  border-radius: 24px;
  box-shadow: none;
  color: #fff;
  margin: 16px;
  padding: 20px;
}

.overview-header {
  text-align: center;
  padding-bottom: 18px;
  margin-bottom: 18px;
  border-bottom: 1px solid rgba(111, 151, 71, 0.25);
}

h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  color: #fff;
}

.overview-section {
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(111, 151, 71, 0.25);
}
.overview-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 6px 0;
}

.label {
  flex: 1;
  font-size: 14px;
  line-height: 1.4;
  color: #fff;
  font-weight: 400;
}
.label.bold {
  font-weight: 700;
}

.value {
  max-width: 48%;
  text-align: right;
  font-size: 14px;
  line-height: 1.4;
  color: #ECECEC;
  font-weight: 400;
}
.value.bold {
  font-weight: 700;
}

.product {
  margin-bottom: 20px;
}
.product:last-child {
  margin-bottom: 0;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}
.product-header span:first-child {
  flex: 1;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
  color: #fff;
}
.product-header span:last-child {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.35;
  color: #ECECEC;
  white-space: nowrap;
}

.product-option {
  margin-top: 4px;
  margin-left: 14px;
  font-size: 15px;
  line-height: 1.45;
  color: #A7A7A7;
}

.total-section {
  padding-top: 20px;
}

.total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.total-row span:first-child {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}
.total-row span:last-child {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/payment-success.page.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,aAAA;EACA,aAAA;AADF;AAEE;EACE,aAAA;EACA,kBAAA;AAAJ;AACI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACN;AAAM;EACE,cAAA;EACA,sCAAA;EACA,+BAAA;EACA,0BAAA;EACA,oBAAA;EACA,oBAAA;AAER;AAAM;EACE,UAAA;EACA,WAAA;EACA,mBAAA;AAER;AAAM;EACE,+BAAA;AAER;AAAM;EACE,uBAAA;EACA,kDAAA;EACA,2CAAA;AAER;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;AADF;AAEE;EACE,UAAA;EACA,YAAA;AAAJ;;AAIA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EACA,YAAA;EACA,mBAAA;EAEA,yCAAA;AAHF;;AAOA;EACE,qBAAA;EAEA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,WAAA;EAEA,YAAA;EACA,aAAA;AAPF;;AAUA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iDAAA;AAPF;;AASA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AANF;;AASA;EACE,oBAAA;EACA,iDAAA;AANF;AAQE;EACE,mBAAA;EACA,iBAAA;AANJ;;AAUA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;AAPF;;AAUA;EACE,OAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAPF;AASE;EACE,gBAAA;AAPJ;;AAWA;EACE,cAAA;EACA,iBAAA;EAEA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AATF;AAWE;EACE,gBAAA;AATJ;;AAaA;EACE,mBAAA;AAVF;AAYE;EACE,gBAAA;AAVJ;;AAcA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AAXF;AAaE;EACE,OAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAXJ;AAcE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAZJ;;AAgBA;EACE,eAAA;EACA,iBAAA;EAEA,eAAA;EACA,iBAAA;EACA,cAAA;AAdF;;AAiBA;EACE,iBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAdF;AAgBE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAdJ;AAiBE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AAfJ","sourcesContent":["@import '../../../theme/mixins';\n\n.progress {\n  width: 100%;\n  padding: 15px;\n  display: flex;\n  .step {\n    width: 33.33%;\n    text-align: center;\n    div {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      ion-checkbox {\n        margin: 0 10px;\n        --checkbox-background-checked: #C1C1C1;\n        --border-color-checked: #C1C1C1;\n        --checkmark-color: #C1C1C1;\n        --border-radius: 50%;\n        pointer-events: none;\n      }\n      div {\n        width: 50%;\n        height: 2px;\n        background: #C1C1C1;\n      }\n      .active {\n        background: var(--accent-color);\n      }\n      ion-checkbox.active {\n        background: transparent;\n        --checkbox-background-checked: var(--accent-color);\n        --border-color-checked: var(--accent-color);\n      }\n    }\n  }\n}\n\n.bubble {\n  position: relative;\n  width: 85px;\n  margin: 0 auto 20px;\n  aspect-ratio: 1;\n  background: white;\n  display: flex;\n  border-radius: 50%;\n  img {\n    width: 75%;\n    margin: auto;\n  }\n}\n\n.bubble::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: -6px;\n  z-index: -1;\n\n  width: 18px;\n  height: 18px;\n  background: inherit;\n\n  transform: translateX(-50%) rotate(45deg);\n}\n\n\n.overview-card {\n  --background: #070707;\n\n  background: #070707;\n  border: 1px solid #8A5B4A;\n  border-radius: 24px;\n  box-shadow: none;\n\n  color: #fff;\n\n  margin: 16px;\n  padding: 20px;\n}\n\n.overview-header {\n  text-align: center;\n  padding-bottom: 18px;\n  margin-bottom: 18px;\n  border-bottom: 1px solid rgba(111, 151, 71, .25);\n}\nh2 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #fff;\n}\n\n.overview-section {\n  padding-bottom: 15px;\n  border-bottom: 1px solid rgba(111, 151, 71, .25);\n\n  &:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n}\n\n.info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 6px 0;\n}\n\n.label {\n  flex: 1;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #fff;\n  font-weight: 400;\n\n  &.bold {\n    font-weight: 700;\n  }\n}\n\n.value {\n  max-width: 48%;\n  text-align: right;\n\n  font-size: 14px;\n  line-height: 1.4;\n  color: #ECECEC;\n  font-weight: 400;\n\n  &.bold {\n    font-weight: 700;\n  }\n}\n\n.product {\n  margin-bottom: 20px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.product-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n\n  span:first-child {\n    flex: 1;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1.35;\n    color: #fff;\n  }\n\n  span:last-child {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1.35;\n    color: #ECECEC;\n    white-space: nowrap;\n  }\n}\n\n.product-option {\n  margin-top: 4px;\n  margin-left: 14px;\n\n  font-size: 15px;\n  line-height: 1.45;\n  color: #A7A7A7;\n}\n\n.total-section {\n  padding-top: 20px;\n}\n\n.total-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  span:first-child {\n    font-size: 18px;\n    font-weight: 700;\n    color: #fff;\n  }\n\n  span:last-child {\n    font-size: 18px;\n    font-weight: 700;\n    color: #fff;\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
